export const environment = {
    production: true,
    apiBase: 'https://prod.v3.goliiive.com/',
    updateSessionAtTime: 15,
    seatsIoPublicKey: '5e28dc45-0ba2-4387-bb38-0bffea1d3212',
    webBase: 'https://web-prod.goliiive.com/',
}
